<template>
    <div
        class="padding7 el-card"
        v-loading="openloading"
        :element-loading-text="loadingText"
        element-loading-background="rgba(0, 0, 0, 0.1)"
    >
        <el-form
            :model="voucherQueryModel"
            label-width="120px"
            label-position="left"
        >
            <div>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item
                            label="品牌"
                            label-width="80px"
                            :required="true"
                        >
                            <el-select
                                v-model="voucherQueryModel.brandId"
                                placeholder="选择品牌"
                                size="mini"
                                class="width100"
                                @change="brandChange"
                                filterable
                            >
                                <el-option
                                    v-for="item in brandList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-show="brandSel">
                        <el-form-item
                            label="门店"
                            label-width="50px"
                            :required="true"
                        >
                            <el-select
                                v-model="voucherQueryModel.store"
                                placeholder="选择门店"
                                size="mini"
                                class="width100"
                                @change="storeChange"
                                filterable
                                multiple
                                @remove-tag="removeTag"
                            >
                                <el-option
                                    label="全选"
                                    value="全选"
                                ></el-option>
                                <el-option
                                    v-for="item in storesList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item
                            label="制单日期"
                            label-width="80px"
                            :required="true"
                        >
                            <el-date-picker
                                v-model="time"
                                type="daterange"
                                range-separator="-"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                align="right"
                                size="mini"
                                style="width: 100%"
                                @change="timeChange"
                                :picker-options="pickerOptions"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="top7">
                        <el-button
                            type="primary"
                            size="mini"
                            icon="el-icon-download"
                            class="pull-right"
                            @click="voucherCreateShow"
                            :disabled="!isSearchVal"
                            >生成凭证</el-button
                        >
                        <el-button
                            type
                            size="mini"
                            icon="el-icon-search"
                            class="pull-right right-20"
                            @click="search"
                            :disabled="!storeSel"
                            >查询</el-button
                        >
                    </el-col>
                </el-row>
            </div>
        </el-form>

        <el-table
            :data="tableData"
            ref="tableData"
            size="mini"
            style="width: 100%"
            border
        >
            <!-- <el-table-column type="selection" width="50" fixed></el-table-column> -->
            <el-table-column label="起止日期" width="200">
                <template slot-scope="scope">
                    <span
                        :class="scope.row.color"
                        style="margin-right: 10px"
                    ></span>
                    {{ dateFormat(scope.row.startTime) }}/{{
                        dateFormat(scope.row.endTime)
                    }}
                </template>
            </el-table-column>
            <el-table-column
                prop="tradeShopName"
                label="门店"
            ></el-table-column>
            <el-table-column
                prop="tradeShopId"
                label="门店编码"
            ></el-table-column>
            <el-table-column
                prop="tsTypeId"
                label="支付方式编码"
            ></el-table-column>
            <el-table-column
                prop="tsTypeName"
                label="支付方式"
            ></el-table-column>
            <el-table-column prop="money" label="支付金额"></el-table-column>
            <el-table-column
                prop="newCardTypeName"
                label="新卡型名称"
            ></el-table-column>
        </el-table>
        <pagerBar
            ref="refPagerBar"
            :apiURL="VoucherDataApi"
            :GetData="getTableData"
            :queryParam="queryParam"
            :isInit="false"
            :errorFunc="errorHandler"
        ></pagerBar>
        <el-dialog
            :visible.sync="Visible"
            title="凭证生成"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            show-close
            append-to-body
        >
            <div class="el-dialog__body" v-if="step2errormsg.length > 0">
                凭证生成详细结果：
                <el-table
                    :data="step2errormsg"
                    size="mini"
                    border
                    :highlight-current-row="true"
                    class="toggletable"
                    ref="detail"
                    id="out-table1"
                >
                    <el-table-column
                        type="index"
                        label="序号"
                        width="50"
                        fixed
                    ></el-table-column>
                    <el-table-column
                        label="门店编码"
                        prop="shopCode"
                        min-width="50"
                        fixed
                    ></el-table-column>
                    <el-table-column
                        label="门店名称"
                        prop="shopName"
                        min-width="60"
                        fixed
                    ></el-table-column>
                    <el-table-column
                        label="结果"
                        prop="voucherResult"
                        class="text-wrapper"
                        min-width="120"
                        fixed
                    ></el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import moment from 'moment'
import config from '@/common/config.js'
import pagerBar from '@/views/pager/pagerBar'
import AjaxHelper from '@/common/js/AjaxHelper'
export default {
    data() {
        return {
            step2errormsg: [],
            Visible: false,
            loadingText: '加载中',
            openloading: false,
            sublistShow: false, //子表默认隐藏,
            selectUser: false,
            isSearchVal: false,
            isVoucherCreate: false,
            queryParam: {},
            brandSel: true,
            storeSel: false,
            CurrnetMID: 0,
            VoucherCreateApi: config.BASE_Middle_API + 'VoucherCreate',
            VoucherDataApi:
                config.BASE_Middle_API + 'VoucherCreate/GetCrmMutilSummaryData', //获取源数据接口 需提供
            Visible: false,
            optionsList: [],
            moduleList: [],
            brandList: [],
            brands: [],
            storesList: [],
            stores: [],
            tableData: [],
            detailData: [],
            accountList: [],
            time: [
                moment().format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD')
            ],
            voucherQueryModel: {
                startTime: moment().format('YYYY-MM-DD'),
                endTime: moment().format('YYYY-MM-DD'),
                brandId: '',
                store: ''
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '昨天',
                        onClick(picker) {
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24)
                            const end = start
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '上月',
                        onClick(picker) {
                            const starttime = moment(
                                moment()
                                    .month(moment().month() - 1)
                                    .startOf('month')
                                    .valueOf()
                            ).format('YYYY-MM-DD HH:mm:ss')
                            const endtime = moment(
                                moment()
                                    .month(moment().month() - 1)
                                    .endOf('month')
                                    .valueOf()
                            ).format('YYYY-MM-DD HH:mm:ss')

                            picker.$emit('pick', [starttime, endtime])
                        }
                    },
                    {
                        text: '本月',
                        onClick: (picker) => {
                            let start = new Date(
                                moment()
                                    .startOf('month')
                                    .format('YYYY-MM-DD HH:mm:ss')
                            )
                            let end = new Date(
                                moment()
                                    .endOf('days')
                                    .format('YYYY-MM-DD HH:mm:ss')
                            )
                            picker.$emit('pick', [start, end])
                        }
                    }
                ]
            },
            multipeleSelectedIds: [],
            selOrder: [],
            selOrderIds: []
        }
    },
    props: {
        tabType: {
            type: String,
            required: true
        }
    },
    components: { pagerBar },
    mounted() {
        this.getModules()
    },
    methods: {
        openloadingHander() {
            this.openloading = true
        },
        closeloadingHander() {
            this.openloading = false
        },
        guid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
                /[xy]/g,
                function (c) {
                    var r = (Math.random() * 16) | 0,
                        v = c == 'x' ? r : (r & 0x3) | 0x8
                    return v.toString(16)
                }
            )
        },
        dateFormat(val) {
            return moment(val).format('YYYY-MM-DD')
        },
        timeChange(val) {
            this.voucherQueryModel.startTime = moment(val[0]).format(
                'YYYY-MM-DD'
            )
            this.voucherQueryModel.endTime = moment(val[1]).format('YYYY-MM-DD')
        },
        errorHandler() {
            this.closeloadingHander()
        },
        search() {
            this.openloadingHander()
            this.queryTick = this.guid()
            cf.event.on('app.chat.messageReceived', function (message) {
                if (this.queryTick === message.sharedMessageId) {
                    this.loadingText = message.message
                }
            })
            this.loadingText = '加载中'
            let shopCodeList = []
            let storeIdList = []
            let confirmData = Object.assign(
                { tick: this.queryTick },
                this.voucherQueryModel
            )
            this.voucherQueryModel.store.forEach((t) => {
                if (t != '全选') {
                    const storeItem = this.storesList.filter((x) => x.id == t)
                    shopCodeList.push(storeItem[0].storeCode)
                    storeIdList.push(t)
                }
            })
            confirmData.shopCodes = shopCodeList.join(',')
            confirmData.storeIDs = storeIdList
            this.queryParam = Object.assign({}, confirmData)
        },
        voucherCreateShow() {
            const _this = this
            _this.openloadingHander()
            _this.queryTick = _this.guid()
            cf.event.on('app.chat.messageReceived', function (message) {
                if (_this.queryTick === message.sharedMessageId) {
                    _this.loadingText = message.message
                }
            })
            _this.loadingText = '加载中'
            //凭证生成接口
            const confirmData = {
                storeIDs: _this.queryParam.storeIDs,

                brandID: _this.queryParam.brandId,
                shopCodes: _this.queryParam.storeCodes,
                startTime: _this.queryParam.startTime,
                endTime: _this.queryParam.endTime
            }
            _this.step2errormsg = []
            _this.Visible = false
            let saveData = Object.assign({ tick: _this.queryTick }, confirmData)
            let queryDatas = Object.assign({}, saveData)
            AjaxHelper.post(
                _this.VoucherCreateApi + '/MutilShopsCrmSummaryDataHandle',
                queryDatas
            )
                .then(function (response) {
                    if (response.result.voucherHandleInfos.length > 0) {
                        _this.Visible = true
                        _this.step2errormsg = response.result.voucherHandleInfos
                        // {
                        //     _this.$notify({
                        //         title: "提示",
                        //         message: response.result.successMsg,
                        //         type: "success",
                        //         position: "bottom-right",
                        //         duration: 0,
                        //     });
                        // }
                        // } else {
                        //     _this.$notify({
                        //         title: "提示",
                        //         message: response.result.errorMsg,
                        //         type: "error",
                        //         position: "bottom-right",
                        //         duration: 0,
                        //     });
                        // }
                    }
                    _this.closeloadingHander()
                })
                .catch(function (error) {
                    _this.closeloadingHander()
                })
        },
        getTableData(d) {
            const _this = this
            _this.tableData = d
            //查询无结果 不允许生成凭证
            if (d.length > 0) {
                _this.isSearchVal = true
            } else {
                _this.isSearchVal = false
            }
            _this.closeloadingHander()
        },

        storeChange(val) {
            this.storeSel = true
            var end = val[val.length - 1]
            if (
                !val.includes('全选') &&
                val.length === this.storesList.length
            ) {
                val.unshift('全选')
            } else if (val.includes('全选') && val.length == 1) {
                this.storesList.map((item) => {
                    val.push(item.id)
                })
            } else if (
                val.includes('全选') &&
                val.length - 1 < this.storesList.length &&
                end == '全选'
            ) {
                val = []
                this.storesList.map((item) => {
                    val.push(item.id)
                })
                val.unshift('全选')
                // this.value = val;
            } else if (
                val.includes('全选') &&
                val.length - 1 < this.storesList.length
            ) {
                val = val.filter((item) => {
                    return item !== '全选'
                })
                // this.value = val;
            }
            // 注意，加上  this.value = val，确保勾选值同步
            this.voucherQueryModel.store = val
        },
        removeTag(val) {
            if (val === '全选') {
                this.voucherQueryModel.store = []
                this.tableData = []
            }
            if (this.voucherQueryModel.store.length == 0) {
                this.isSearchVal = false
            }
        },
        brandChange(val) {
            this.brandSel = true
            this.isSearchVal = false
            this.storeSel = false
            this.voucherQueryModel.store = ''
            this.storesList = this.stores.filter((x) => x.brandID === val)
        },
        statusSearch(item) {
            this.storeSel = false
            //this.brandSel = false;
            this.CurrnetMID = item.id
            this.voucherQueryModel.brandId = ''
            this.voucherQueryModel.store = ''
            this.brandList = this.brands.filter((x) => x.moduleID == item.id)
            this.isSearchVal = false
        },
        getModules() {
            const _this = this
            this.openloadingHander()
            AjaxHelper.get(
                _this.VoucherCreateApi + '/GetModules?tabType=' + _this.tabType
            )
                .then(function (response) {
                    if (response.success) {
                        _this.moduleList = response.result.modules
                        if (_this.moduleList.length > 0) {
                            const firstItem = _this.moduleList[0]
                            _this.CurrnetMID = firstItem.id
                            _this.brands = response.result.brands
                            _this.stores = response.result.stores
                            _this.brands.forEach((x) => {
                                _this.moduleList.forEach((element) => {
                                    if (element.id == x.moduleID) {
                                        // x.name = element.name + "/" + x.name;
                                        _this.brandList.push(x)
                                    }
                                })
                            })
                        }
                    }
                    _this.closeloadingHander()
                })
                .catch(function (error) {
                    _this.closeloadingHander()
                })
        },
        handleClose(done) {
            this.isVoucherCreate = false
            done()
        }
    }
}
</script>

<style scoped>
.text-wrapper {
    word-wrap: break-word;
    word-break: break-all;
}
.minicard {
    height: auto !important;
    display: block;
    width: 200px;
    position: absolute;
    right: 0;
    z-index: 9989;
    top: 80px;
}
.minicard .el-button {
    width: 150px;
    margin: 5px 0;
}
.el-dialog__body {
    padding: 10px 15px !important;
}

dl.loglist p {
    font-weight: 600;
    margin: 20px 0 10px 0;
}
dl.loglist dd {
    padding: 15px 0;
    color: #999999;
    display: block;
}
.subname-enter-active,
.subname-leave-active {
    transition: opacity 0.6s;
}
/*指定隐藏时的样式*/

.subname-enter,
.subname-leave-to {
    opacity: 0;
}

.subCard {
    position: absolute;
    z-index: 2900;
    width: 55%;
    right: 0;
}
dl,
dt,
dd {
    margin: 0;
    padding: 0;
}
.w25 {
    width: 25%;
    float: left;
}
.w75 {
    width: 75%;
    float: left;
}
.el-card {
    border: 0;
    height: calc(100vh - 225px);
    overflow-y: auto;
}
.padding7 {
    padding: 7px;
}
.top7 {
    padding: 7px 0 0 0;
}
</style>
